import React from "react";

import locationIcon from "./../../assets/Location.svg";
import CustomTooltip from "./../Pages/CustomTooltip/CustomTooltip";

const LocationModal = ({ isOpen, onClose, location }) => {
  if (!isOpen) return null;

  

  return (
    <div className="location-modal-overlay">
      <div className="location-modal-content">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ fontSize: "22px", fontWeight: "700" }}>
            Location Details
          </div>
          <CustomTooltip text="Close" placement="top">
            <button className="btn-close" onClick={onClose}></button>
          </CustomTooltip>
        </div>
        <div className="location-details">
          <div className="location-icon">
            <img
              src={locationIcon}
              style={{
                width: "28px",
              }}
              alt="location"
            />
          </div>
          <div className="location-text">
            <p className="location-name">{location?.name}</p>
            <p>{location?.address}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationModal;
